import { render, staticRenderFns } from "./OrdersCard.vue?vue&type=template&id=7fcdd0de&scoped=true&"
import script from "./OrdersCard.vue?vue&type=script&lang=js&"
export * from "./OrdersCard.vue?vue&type=script&lang=js&"
import style0 from "./OrdersCard.vue?vue&type=style&index=0&id=7fcdd0de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcdd0de",
  null
  
)

export default component.exports